var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYourLocationPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 150,
  height: 150,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 75,
  r: 74.5,
  fill: "#FA0",
  stroke: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M75 32.609c16.35 0 29.348 13.478 29.348 30.435C104.348 80 75 123.913 75 123.913S45.652 80 45.652 63.043C45.652 46.088 58.65 32.61 75 32.61"
})));
export { SvgYourLocationPin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDE1MCAxNTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9Ijc1IiBjeT0iNzUiIHI9Ijc0LjUiIGZpbGw9IiNGRkFBMDAiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTc1IDMyLjYwODdDOTEuMzUwOSAzMi42MDg3IDEwNC4zNDggNDYuMDg3IDEwNC4zNDggNjMuMDQzNUMxMDQuMzQ4IDgwIDc1IDEyMy45MTMgNzUgMTIzLjkxM0M3NSAxMjMuOTEzIDQ1LjY1MjIgODAgNDUuNjUyMiA2My4wNDM1QzQ1LjY1MjIgNDYuMDg3IDU4LjY0OTEgMzIuNjA4NyA3NSAzMi42MDg3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";